// extracted by mini-css-extract-plugin
export default {"userForm":"Sidebar_userForm__AkBTQ","formHeader":"Sidebar_formHeader__AG8CQ","welcomePage":"Sidebar_welcomePage__dGNSa","formText":"Sidebar_formText__0m2sv"};